<!--
 * @Description  : 纯文本的展示，可以点击跳转
-->

<template minapp="mpx" xlang="wxml">
  <view class="notes-page">
    <view class="content-notes" wx:for="{{notesList}}" wx:key="index">
      <view wx:if="{{item.title}}" class="title">
        {{ item.title }}
      </view>
      <view wx:if="{{item.subTitle}}" class="sub-title">{{ item.subTitle }}</view>
      <view wx:if="{{item.list}}" class="caption-text">
        <view wx:for="{{item.list}}" wx:key="index" class="caption-item">
          <view class="item-text"></view>
          <rich-text nodes="{{item}}"></rich-text>
        </view>
      </view>
      <view wx:if="{{item.text}}" class="caption-url">
        <view class="caption-url-text">参看{{ item.text }}</view>
      </view>
    </view>
    <view class="solt">
      <slot name="{{'tabrefund'}}"></slot>
    </view>

    <image wx:if="{{isShowTabIcon}}" class="tab-icon" src="{{imgSrc}}"></image>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { goTo } from '@didi/webx-js'

  createComponent({
    props: {
      title: {
        type: String,
        value: ''
      },
      notesList: {
        type: Array,
        value: () => []
      },
      isShowTabIcon: {
        type: Boolean,
        value: false
      }
    },
    data() {
      return {
        imgSrc: 'https://dpubstatic.udache.com/static/dpubimg/tuXMEH7OgWQGSylGuPx0R.png'
      }
    },
    methods: {}
  })
</script>

<style scoped lang="stylus">
  .notes-page
    position relative
    // border-radius 8px
    overflow hidden
    .content-notes
      opacity 1
      display flex
      flex-direction column
      padding 0px
      box-sizing border-box
      background #FFFFFF
      z-index 0
      .title
        display flex
        height 46px
        align-items center
        margin 0 12px
        border-bottom 0.5px rgba(0, 0, 0, 0.08) solid
        font-family PingFangSC-Medium
        font-size 16px
        font-weight normal
        line-height 19px
        letter-spacing 0px
        color #1473FF
      .sub-title
        margin 12px 12px 0 12px
        font-family PingFangSC-Medium
        font-size 14px
      .caption-text
        box-sizing border-box
        padding 0 12px 12px
        .caption-item
          display flex
          font-family PingFangSC-Regular
          font-size 14px
          font-weight normal
          line-height 18px
          letter-spacing 0px
          color #666666
          margin-top 12.5px
          .item-text
            height 18px
            flex none
            width 16px
            display flex
            align-items center
          .item-text::before
            content ''
            display inline-block
            width 6px
            height 6px
            background #D8D8D8
            border-radius 50%
      .caption-url
        display flex
        font-family PingFangSC-Regular
        font-size 14px
        font-weight normal
        line-height 18px
        letter-spacing 0px
        padding 0 12px 12px
        margin-top 12px
        .caption-url-text
          color #666666
          word-wrap normal 
          word-break break-all
        .caption-url-text::before
          content ''
          display inline-block
          width 4px
          height 4px
          background #999
          border-radius 100%
          vertical-align middle
          margin-right 5px
    .solt
      background-color #fff
    .tab-icon
      position absolute
      right 8px
      top 6.6px
      width 48px
      height 50.4px
      opacity 1
      z-index 2
</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>